import React from 'react';
import { MailIcon } from 'lucide-react';
import { activities, channel, channelFacts } from '../data/channel';
export function AboutAuthor() {
  return <section id="about" aria-labelledby="about-title" className="scroll-mt-20 border-t border-line py-20 md:py-28" data-id="element-14" data-mp="1e7usrc6n556z">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-12" data-id="element-15" data-mp="1nzs6apl4g98v">
        <div className="lg:col-span-7" data-id="element-16" data-mp="1o1v3puolt4nm">
          <h2 id="about-title" className="font-display text-3xl font-semibold tracking-tight md:text-5xl md:leading-[1.1]" data-id="element-17" data-mp="109ebwsf2dyb4">
            Привіт, я {channel.author}
          </h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-paper/85 md:text-xl" data-id="element-18" data-mp="19avxurf5ku7q">
            Я в захваті від нестандартних подорожей. Тут ви знайдете звіти про всі види моїх аутдорних активностей —
            чесно, з усіма підйомами, туманами й мокрими черевиками.
          </p>
          <ul className="mt-8 flex flex-wrap gap-2" aria-label="Чим я займаюсь" data-id="element-19" data-mp="2gofxf1sjxsuc">
            {activities.map(a => <li key={a} className="rounded-full border border-line px-4 py-2 text-sm font-semibold text-paper" data-id="element-20" data-mp="2wkjnkewq0j8g">
                {a}
              </li>)}
          </ul>

          <div className="mt-10 border-t border-line pt-6" data-id="element-21" data-mp="35kovcq5ttjn5">
            <p className="text-sm text-muted" data-id="element-22" data-mp="35l82rcxuopmx">Співпраця, ідеї маршрутів чи просто привіт:</p>
            <a href={`mailto:${channel.email}`} className="mt-2 inline-flex items-center gap-2 font-display text-xl font-semibold text-paper transition-colors duration-150 hover:text-ember md:text-2xl" data-id="element-23" data-mp="3aj9l1vngckxc">
              <MailIcon className="h-5 w-5 text-ember" aria-hidden="true" data-id="element-24" data-mp="2mu77ozzupe8n" />
              {channel.email}
            </a>
          </div>
        </div>

        <dl className="grid grid-cols-2 gap-x-8 gap-y-8 self-end border-t border-line pt-8 lg:col-span-5 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-25" data-mp="2rlp4rcyr6uoc">
          {channelFacts.map(fact => <div key={fact.label} data-id="element-26" data-mp="1z3bi89ivav4k">
              <dt className="text-sm text-muted" data-id="element-27" data-mp="1z2joz5cqt9hg">{fact.label}</dt>
              <dd className="mt-1 font-display text-xl font-semibold text-paper" data-id="element-28" data-mp="32e8t47krquzs">{fact.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}